import Vue from 'vue';
import swal from 'sweetalert2';

var swalPlugin = {};

swalPlugin.install = function (Vue) {
  Vue.prototype.$swal = swal;
};

Vue.use(swalPlugin);


//////////////////
// WEBPACK FOOTER
// ./plugins/sweetmodal.js
// module id = ./plugins/sweetmodal.js
// module chunks = 152